module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';

	fox.registerWidget('AdvancedFilter_Dropdown', {

		configure: function () {

			this.registerOptions('', {
				template: 'advancedFilterDropdown',
				'embed.container': '.dd-filter',
				'handleDom.toggle.targetWidget': '#counter',
				'handleDom.toggle.target': '.counter-wrapper',
				widgets: {
					counter: {
						widget: 'Widget',
						template: 'advancedFilterDropdown_counter',
						autoRender: true,
						embed: {
							container: '.tab'
						}
					}
				},
				handleWom: {
					renderChanges: {
						widget: '@this',
						event: 'change',
						callback: '_renderChanges'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this.callParent('running', arguments);

			this.counter = this.wom1('#counter');
		},

		toggleFilter: function (el) {
			var elm = this.dom1('.mc-advanced-filter-dropdown');

			this._unbindWindowEvents();

			if (this.isOpened === true) {
				fox.dom.removeClass('opened', elm);
				this.isOpened = false;

				return;
			}

			fox.dom.addClass('opened', elm);
			this.isOpened = true;
			this._bindWindowEvents(elm);
		},

		collapse: function () {
			this.isOpened = true;
			this.toggleFilter();
		},

		apply: function () {
			this.callParent('apply', arguments);

			this.collapse();
		},

		reset: function () {
			this.callParent('reset', arguments);

			this.collapse();
			this._renderChanges();
		},

		_bindWindowEvents: function (el) {
			$(document).on('click keyup', {widget: this, el: el}, this._hide);
		},

		_unbindWindowEvents: function () {
			$(document).off('click keyup', this._hide);
		},

		_hide: function (e) {
			var container = $(e.data.el);
			var cName = 'opened';

			if (e.type === 'keyup') {
				if (e.keyCode && e.keyCode === 27) {
					e.data.widget.collapse();
				}

				return;
			}

			if (!container.is(e.target) &&
				container.has(e.target).length === 0 &&
				e.data.widget.isOpened) {
					e.data.widget.collapse();
			}
		},

		_renderChanges: function (data) {
			this.counter.setTemplateOptions('number', data === 'simpleChange' ? 'simpleChange' : this.getChangesNumber());
			this.counter.render();
		}

	}, 'AdvancedFilter');
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/advancedFilterDropdown.js
// module id = 292
// module chunks = 2